
import { Select } from 'antd'
import { useSelector } from 'react-redux'

import SmartTable, { SmartTableDataTypes } from '../../../Components/shared/SmartTable'
import { canonizeString, validateFormInput } from '../../../utils'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const Option = Select.Option

const ContactPersonsTable = ({ contactPersons, loading, additionalActions, onChangeSelect, allOptionText, selectValue, optionsSelect }) => {
  const t = useSelector(selectTranslate)

  const COLUMNS = [
    { type: SmartTableDataTypes.ID, key: 'id' },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Lastname'),
      key: 'lastname',
      validate: data => {
        return validateFormInput('freeText', data, true)
      }
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Firstname'),
      key: 'firstname',
      validate: data => {
        return validateFormInput('freeText', data, true)
      }
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Email'),
      key: 'email',
      validate: data => {
        return validateFormInput('email', data)
      }
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Phone'),
      key: 'phone'
    }
  ]

  const renderSelect = () => {
    if (optionsSelect) {
      return (
        <div>
          <Select
            showSearch
            className='select-sector'
            value={selectValue === null ? 'all' : selectValue}
            filterOption={(input, option) =>
              canonizeString(option.props.children).indexOf(
                canonizeString(input)
              ) > -1}
            onChange={e => onChangeSelect(e)}
          >
            {<Option key='all' value='all' title={allOptionText}>{allOptionText}</Option>}

            {optionsSelect.map(s => {
              return (
                <Option key={s.id} value={s.id} title={s.name}>
                  {s.name}
                </Option>
              )
            })}
          </Select>
        </div>
      )
    }
  }

  return (
    <>
      {renderSelect()}
      <SmartTable
        columns={COLUMNS}
        data={contactPersons}
        loading={loading}
        noDataText={t('There are no contact persons')}
        additionalActions={additionalActions}
      />
    </>
  )
}

export default ContactPersonsTable
